export default __webpack_public_path__ + "static/media/close_square_red.8473824b.svg";